__turbopack_context__.v({
  "currentYear": "PdpPriceHistory-module__1I4KOG__currentYear",
  "date": "PdpPriceHistory-module__1I4KOG__date",
  "details": "PdpPriceHistory-module__1I4KOG__details",
  "event": "PdpPriceHistory-module__1I4KOG__event",
  "historyFade": "PdpPriceHistory-module__1I4KOG__historyFade",
  "historyFadeHidden": "PdpPriceHistory-module__1I4KOG__historyFadeHidden",
  "previousYear": "PdpPriceHistory-module__1I4KOG__previousYear",
  "row": "PdpPriceHistory-module__1I4KOG__row",
  "withMls": "PdpPriceHistory-module__1I4KOG__withMls",
  "year": "PdpPriceHistory-module__1I4KOG__year",
});
